/**
 * "Built by" credit shown beside the copyright line in every footer that
 * carries one (SEO handoff 2026-10-19, section 10c). One component, so the
 * landing and /learn footers cannot drift apart.
 */
export default function BuiltByCredit() {
  return (
    <>
      {/* Own line on phones (a wrapped line would start with the dot), inline from sm up. */}
      <span aria-hidden="true" className="hidden sm:inline">
        {' · '}
      </span>
      <a
        href="https://blockchainslc.com"
        rel="noopener"
        className="block sm:inline whitespace-nowrap hover:text-base-content transition-colors"
      >
        Built by Blockchain Solutions
      </a>
    </>
  );
}
